import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, ZapIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function WhatsAppResultsSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-gray-50 py-20 sm:py-28" data-id="element-206">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-207">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} data-id="element-208">
          {/* Section header */}
          <motion.div variants={itemVariants} className="mb-16 text-center" data-id="element-209">
            <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-electric-blue/10 to-bright-orange/10 px-4 py-2 text-sm font-semibold text-electric-blue" data-id="element-210">
              <MessageCircleIcon className="h-4 w-4" data-id="element-211" />
              Resultados
            </span>
            <h2 className="font-heading text-3xl font-extrabold text-gray-900 sm:text-4xl md:text-5xl" data-id="element-212">
              Clientes llegando directo a tu WhatsApp
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-lg text-gray-600" data-id="element-213">
              Resultados reales de campañas activas generando mensajes a bajo
              costo.
            </p>
          </motion.div>

          {/* Image Showcase */}
          <motion.div variants={itemVariants} className="mx-auto max-w-4xl overflow-hidden rounded-3xl bg-gradient-to-r from-electric-blue to-bright-orange p-1 shadow-2xl" data-id="element-214">
            <div className="rounded-[22px] bg-white p-2 sm:p-4" data-id="element-215">
              <img src="https://cdn.magicpatterns.com/uploads/doTGYwhC83EqvD1SoBzShH/65d7b774-e2ac-44db-ad59-7d81883c2f83.png" alt="Dashboard de Meta Ads mostrando resultados de campañas de WhatsApp" className="h-auto w-full rounded-xl object-cover" data-id="element-216" />
            </div>
          </motion.div>

          {/* CTA Button */}
          <motion.div variants={itemVariants} className="mt-10 text-center" data-id="element-217">
            <button onClick={scrollToPricing} className="group inline-flex items-center gap-2 rounded-2xl bg-gradient-to-r from-electric-blue to-bright-orange px-10 py-4 text-lg font-bold text-white shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl" data-id="element-218">
              <ZapIcon className="h-6 w-6" data-id="element-219" />
              Quiero aprender a hacerlo
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}